import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';

import {Observable} from 'rxjs';
import {SupportContact} from '@models/adminstration/organization/support-contact/support-contact';
import {ApiLocationService} from '@services/api-location/api-location.service';
import {HTTPS_REQUEST_OPTIONS} from '@constants/https-request-options/https-request-options';


@Injectable({
  providedIn: 'root'
})
export class ContactsService {
  private readonly BASE_URL: string;
  ORGANIZATION_SUPPORT_CONTACTS_LIST_URL_SUFFIX: string = '/api/web/admin/tenant/:id/contacts';
  ORGANIZATION_SUPPORT_CONTACT_SAVE_URL_SUFFIX: string = '/api/web/admin/tenant/:id/contacts/:contact';
  ORGANIZATION_SUPPORT_CONTACT_DELETE_URL_SUFFIX: string = '/api/web/admin/tenant/:id/contacts/:contact';


  constructor(private http: HttpClient,
              private apiLocation: ApiLocationService) {
    this.BASE_URL = this.apiLocation.getLocation();
  }

  public listContacts(organizationId: number): Observable<any> {
    let url: string = this.BASE_URL + this.ORGANIZATION_SUPPORT_CONTACTS_LIST_URL_SUFFIX;
    url = url.replace(':id', String(organizationId));

    return this.http.get<SupportContact[]>(url, HTTPS_REQUEST_OPTIONS);
  }

  public saveContact(organizationId: number, contact: SupportContact): Observable<any> {
    let url: string = this.BASE_URL + this.ORGANIZATION_SUPPORT_CONTACT_SAVE_URL_SUFFIX;
    url = url.replace(':id', String(organizationId));
    url = url.replace(':contact', String(contact.id));

    return this.http.post<SupportContact>(url, contact, HTTPS_REQUEST_OPTIONS);
  }

  public deleteContact(organizationId: number, contactId: number): Observable<any> {
    let url: string = this.BASE_URL + this.ORGANIZATION_SUPPORT_CONTACT_DELETE_URL_SUFFIX;
    url = url.replace(':id', String(organizationId));
    url = url.replace(':contact', String(contactId));

    return this.http.delete<boolean>(url, HTTPS_REQUEST_OPTIONS);
  }


  public copyContactProperties(source: SupportContact, target: SupportContact | null): SupportContact {
    if (target == null) {
      target = new SupportContact();
    }

    target.id = source.id;
    target.type = source.type;
    target.name = source.name;
    target.email = source.email;
    target.phone = source.phone;
    target.image = source.image;
    return target;
  }

}
